'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Top = void 0;
const $ = require("jquery");
class Top {
    constructor() {
        $('.bulletSlideTopPc picture:nth-child(n+2)').hide();
        $('.bulletSlideTopSp img:nth-child(n+2)').hide();
        setInterval(() => {
            $(".bulletSlideTopPc picture:first-child").fadeOut(1000);
            $(".bulletSlideTopPc picture:nth-child(2)").fadeIn(1000);
            $(".bulletSlideTopPc picture:first-child").appendTo(".bulletSlideTopPc");
            $(".bulletSlideTopSp img:first-child").fadeOut(1000);
            $(".bulletSlideTopSp img:nth-child(2)").fadeIn(1000);
            $(".bulletSlideTopSp img:first-child").appendTo(".bulletSlideTopSp");
        }, 3000);
        $('.trigBusinessSlide').on('mouseenter', (e) => {
            const index = Number($('.trigBusinessSlide').index(e.currentTarget));
            $('.bulletBusinessSlide').attr('data-is-show', 'false');
            $('.bulletBusinessSlide').eq(index).attr('data-is-show', 'true');
        });
    }
}
exports.Top = Top;
exports.default = Top;
